import { json } from 'react-router-dom'
import Axois from '../utils/axios'
import EventEmitter from '../utils/eventEmitter';



export const loadDeferredRevenues = async () => {
  let response = await Axois.get('deferred-revenues').catch(err => { throw new Error('Could not fetch data!\nPlease check your network connectivity!') })
    const responseData = await response.data;
    return responseData;
  return [];
}


export const loadDeferredRevenueAndSetup = async (action) => {
  try {
    switch (action) {
      case 'new':
        let requests = await Axois.get('/setups/deferred-revenue');
        const responseData = await requests.data;
        return {...responseData, deferred_revenue: {}};
      
      default:
        let response = await Axois.get('/deferred-revenues/'+action);
        const responseJson = await response.data;
        return responseJson;
    }
  }catch (err) {
    console.log(err);
  }
}



const useDeferredRevenueAPI = () => {
  
  const saveDeferredRevenue = async (data, success) => {
    try {
      const response = await Axois.post('/deferred-revenues', data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('save_deferred_revenue_response', {status: 'draft', seo: data.seo});
    }catch(err) {
      console.log(err);
    }
  };

  const updateRevenueStatus = async (seo, status, success) => {
    try {
      const response = await Axois.patch('/deferred-revenues/'+seo, {status: status});
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('updateStatusRevenueResponse', {status: status});
    }catch (err) {
      console.log(err);
    }
  }

  const update = async (seo, data, success) => {
    try {
      const response = await Axois.put('/deferred-revenues/'+seo, data);
      const responseData = await response.data;
      success(responseData.message);
      EventEmitter.dispatch('save_deferred_revenue_response', {status: 'draft', seo: data.seo});
    }catch (err) {
      console.log(err);
    }
  }

  return { saveDeferredRevenue, updateRevenueStatus, update };
}


export default useDeferredRevenueAPI;